import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAMetal,
  getMetal,
  resetState,
} from "../features/metal/metalSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const Metallist = () => {
  const [open, setOpen] = useState(false);
  const [metalId, setmetalId] = useState("");
  const [loading, setLoading] = useState(true);

  const showModal = (e) => {
    setOpen(true);
    setmetalId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(resetState());
      await dispatch(getMetal());
      setLoading(false);
    };

    fetchData();
  }, [dispatch]);

  const metalState = useSelector((state) => state.metal.Metal);
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const data1 = metalState.map((metal, index) => ({
    key: index + 1,
    name: metal.metal_name,
    action: (
      <>
        <Link
          to={`/admin/metal/${metal._id}`}
          className=" fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(metal._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deleteMetal = (e) => {
    dispatch(deleteAMetal(e));
    setOpen(false);
    setTimeout(() => {
      dispatch(getMetal());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Metals</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteMetal(metalId);
        }}
        title="Are you sure you want to delete this metal?"
      />
    </div>
  );
};

export default Metallist;